import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Breadcrumbs from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Breadcrumbs';
import React, { ChangeEvent, useEffect, useState } from 'react';
import Loader from '../../_components/molecules/Loader';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import DashedStandardDropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/DashedStandardDropdown';
import {
  BasicTable,
  CardComponent,
  Columns,
  CostTrend,
  Layers,
  OverviewCard,
  PageTitleAndSubTitle,
  SvgTable,
  ToggleGroup,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import wasteCalculatorDetailsPageMessages from '../../core-utils/messages/wasteCalculatorDetailsPageMessages';
import {
  downloadPdf,
  handleDownloadCSV,
} from '../../core-utils/helper-utils/downloadPdfHelper';
import { CircularLoader, Typography } from '@HomaHealth/ui-component-library';
import { useStores } from '../../stores';
import TabSelection from '../../_components/molecules/TabSelection';
import OverviewCardTooltipContent from '../../_components/atoms/OverviewCardTooltipContent';
import { getCohortValue } from '../../core-utils/helper-utils/overviewCardHelper';
import {
  numberToCurrencyFormatter,
  numFormatterWithSuffix,
} from '../../core-utils/helper-utils/helper';
import properties from '../../core-utils/properties';
import { formatWasteCalculatorSummary } from '../../core-utils/helper-utils/wasteCalculatorHelper';
import axios from 'axios';
import { pageScrollDown } from '../SummaryPage';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import {
  CostValues,
  MemberValues,
} from '../../core-utils/helper-utils/summaryReportHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { useNavigate, useLocation } from 'react-router-dom';
import { PATIENT_DETAILS, WASTE_CALCULATOR } from '../../core-utils/routes';
import {
  CostTrendDataFormat,
  getMonth,
  subCategoriesColumns,
  subCategoriesDefaultColumns,
  subCatergoriesTableColumns,
  topProvidersTableColumns,
} from '../../core-utils/helper-utils/wasteCalculatorInternalPageHelper';
import MedicalHistoryDetails from '../../_components/organisms/MedicalHistoryDetails';
import {
  formatMemberClaim,
  getTextWithToolTip,
} from '../../core-utils/helper-utils/riskPatientDetailsHelper';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import componentConstants from '../../core-utils/messages/componentConstants';
import {
  handleHeaderMouseEnter,
  handleHeaderMouseLeave,
} from '../../core-utils/helper-utils/tableSortHelper';
import CustomColumnsTable from '../../_components/organisms/CustomColumnsTable';
import {
  formatMembersListData,
  getColumns,
} from '../../core-utils/helper-utils/customColumnsHelper';
import DateFilter from '../../_components/molecules/DateFilter';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '40px 0px 66px 63px',
    width: '1182px',
  },
  breadcrumbsGrid: {
    marginBottom: '20px',
  },
  tabContent: {
    marginTop: '28px',
  },
  topCardsGrid: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    marginBottom: '14px',
  },
  overviewVisualsGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '28px',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    height: '16px',
    width: '16px',
  },
  tableLoaderGrid: {
    minHeight: '380px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const WasteCalculatorDetailsPage = () => {
  //Constants
  const { classes } = useStyles();
  const messages =
    wasteCalculatorDetailsPageMessages.WASTE_CALCULATOR_INTERNAL_PAGE;
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
  const listOfFactors = messages.FACTORS_DROPDOWN_OPTIONS;

  const employerGroupStore = useStores().employerGroupStore;
  const summaryStore = useStores().summaryCardsStore;
  const recommendationsStore = useStores().recommendedTabStore;
  const wasteCalculatorStore = useStores().wasteCalculatorStore;
  const memberSummaryStore = useStores().memberSummaryStore;

  const navigate = useNavigate();
  const location = useLocation();
  const stateFromHistory: any = location.state;

  //States
  const quaterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quaterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();

  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [selectedFactor, setSelectedFactor] = useState<string>(
    stateFromHistory?.selectedFactor,
  );
  const [loader] = useState<any>(<Loader />);
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );

  //States for Top Card
  const [cohortMembers, setCohortMembers] = useState<MemberValues>({
    members: '0',
    employees: '0',
    dependents: '0',
  });
  const [cohortCost, setCohortCost] = useState<CostValues>({
    rx: '$0.00',
    medical: '$0.00',
    total: '$0.00',
  });
  const [totalClaims, setTotalClaims] = useState<number>(0);

  //States for Sub Categories
  const [subCategoriesData, setSubCategoriesData] = useState<any[]>([]);
  const [
    columnIdForSubCategories,
    setColumnIdForSubCategories,
  ] = useState<string>();
  const [
    subCategoriesPageNumber,
    setSubCategoriesPageNumber,
  ] = useState<number>(1);
  const [subCategoriesPageSize] = useState<number>(5);
  const [
    subCategoriesTotalPages,
    setSubCategoriesTotalPages,
  ] = useState<number>(0);
  const [subCategoriesLoading, setSubCategoriesLoading] = useState<boolean>(
    false,
  );
  const [subCategoriesSortField, setSubCategoriesSortField] = useState<string>(
    'totalCost',
  );
  const [subCategoriesSortOrder, setSubCategoriesSortOrder] = useState<number>(
    -1,
  );

  //States for Top Providers
  const [topProvidersToggle, setTopProvidersToggle] = useState<
    'left' | 'right'
  >('left');
  const [topProvidersData, setTopProvidersData] = useState<any[]>([]);
  const [
    columnIdForTopProviders,
    setColumnIdForTopProviders,
  ] = useState<string>();
  const [topProvidersPageNumber, setTopProvidersPageNumber] = useState<number>(
    1,
  );
  const [topProvidersPageSize] = useState<number>(5);
  const [topProvidersTotalPages, setTopProvidersTotalPages] = useState<number>(
    0,
  );
  const [topProvidersLoading, setTopProvidersLoading] = useState(true);
  const [topProvidersSortField, setTopProvidersSortField] = useState<string>(
    'totalCost',
  );
  const [topProvidersSortOrder, setTopProvidersSortOrder] = useState<number>(
    -1,
  );

  //States for Cost Trend Data
  const [costTrendTotalCostData, setCostTrendTotalCostData] = useState<
    CostTrendDataFormat[]
  >([]);
  const [costTrendClaimsData, setCostTrendClaimsData] = useState<any[]>([]);
  const [costTrendChartXAxisValues, setCostTrendChartXAxisValues] = useState<
    any[]
  >([]);

  //States for Members Details Data
  const [memberListData, setMemberListData] = useState<any[]>([]);
  const [clickedMember, setClickedMember] = useState<string>('');
  const [selectedColumns, setSelectedColumns] = useState<string[]>(
    subCategoriesDefaultColumns,
  );
  const [tableColumns, setTableColumns] = useState<Columns[]>(
    getColumns(subCategoriesDefaultColumns),
  );
  const [membersPageNumber, setMembersPageNumber] = useState<number>(1);
  const [membersPageSize] = useState<number>(5);
  const [membersTotalPages, setMembersTotalPages] = useState<number>(0);
  const [membersLoading, setMembersLoading] = useState(true);
  const [membersSortField, setMembersSortField] = useState<string>('totalCost');
  const [membersSortOrder, setMembersSortOrder] = useState<number>(-1);

  //snacker bar variables and functions
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const breadcrumbs = [
    [
      'text',
      messages.TITLE,
      {
        color: patientAccessTheme.palette.primary[500],
        fontWeight: 500,
      },
      () => navigate(WASTE_CALCULATOR),
    ],
    [
      'text',
      selectedFactor,
      {
        color: patientAccessTheme.palette.text.highemphasis,
        fontWeight: 600,
      },
    ],
  ];

  //Functions

  const handleReportDownload = () => {
    downloadPdf(
      'individualWasteCalculatorReport',
      {
        ...payload,
        employer:
          employerGroupStore?.employerGroupResponseData?.employer_group_name,
        category: selectedFactor,
        maxClaimDate:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
      },
      handleOpenSnackBar,
      'open',
    );
    handleOpenSnackBar(
      snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
      'info',
      6000,
    );
  };

  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        messages.RECOMMENDATIONS_TAB.TITLE,
        recommendationsStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const handleTablePageChangeForSubCatories = (
    event: ChangeEvent<unknown>,
    page: number,
  ) => {
    setSubCategoriesPageNumber(page);
  };

  const handleTablePageChangeForTopProviders = (
    event: ChangeEvent<unknown>,
    page: number,
  ) => {
    setTopProvidersPageNumber(page);
  };

  const handleTablePageChangeForMembers = (
    event: ChangeEvent<unknown>,
    page: number,
  ) => {
    setMembersPageNumber(page);
  };

  const handleMemberClick = (value: string) => {
    setClickedMember(value);
  };

  const wastageCostTrendProps = (
    costTrendTotalCostData: any,
    costTrendClaimsData: any,
    costTrendChartXAxisValues: any,
  ) => {
    return {
      yAxisTitle: messages.WASTAGE_COST_TREND_CHART.Y_AXIS_LABEL,
      sAxisTitle: messages.WASTAGE_COST_TREND_CHART.S_AXIS_LABEL,
      chartTitle: messages.WASTAGE_COST_TREND_CHART.TITLE,
      chartSubTitle:
        messages.WASTAGE_COST_TREND_CHART.SUB_TITLE.PART1 +
        selectedFactor +
        messages.WASTAGE_COST_TREND_CHART.SUB_TITLE.PART2,
      datasetProp: [
        {
          seriesname: messages.COST_TREND_CHART.SERIES_NAME[0],
          plottooltext:
            messages.COST_TREND_CHART.SERIES_NAME[0] + ' - $$dataValue',
          data: costTrendTotalCostData,
          color: patientAccessTheme.palette.primary[400],
        },
        {
          seriesname: messages.COST_TREND_CHART.SERIES_NAME[1],
          plottooltext:
            messages.COST_TREND_CHART.SERIES_NAME[1] + ' - $dataValue',
          data: costTrendClaimsData,
          color: patientAccessTheme.palette.ribbonChart?.legendColor1,
          parentyaxis: 'S',
          renderas: 'line',
          anchorBgColor: patientAccessTheme.palette.ribbonChart?.legendColor1,
        },
      ],
      xAxisValues: costTrendChartXAxisValues,
      cardWidth: '1175px',
      chartWidth: '1160',
      spaceBetweenTitleAndChart: '54px',
      cardHeight: '435px',
    };
  };

  const handleMenuItemForSubCategories = (
    event: any,
    column: any,
    item: any,
  ) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    setSubCategoriesSortField(sortColumnName);
    setSubCategoriesSortOrder(sortOrder);
  };

  const handleMenuItemForTopProviders = (
    event: any,
    column: any,
    item: any,
  ) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }
    setTopProvidersSortOrder(sortOrder);
    setTopProvidersSortField(sortColumnName);
  };

  const handleMenuItemForMembers = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }
    setMembersSortOrder(sortOrder);
    setMembersSortField(sortColumnName);
  };

  const handleChangeColumns = () => {
    setTableColumns(getColumns(selectedColumns));
    getMembersList();
  };

  const handleExportCSV = () => {
    handleDownloadCSV(
      properties.aiqBaseUrl +
        properties.wasteCalculatorBaseUrl +
        properties.wastageCategoryMembersList +
        '/csv',
      membersListRequestBody,
      `${selectedFactor}.csv`,
      handleOpenSnackBar,
    );
  };

  //APIs
  const getWasteCalculatorSummary = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.wasteCalculatorBaseUrl +
          properties.wastageInternalSummary,

        {
          ...payload,
          member_unique_id_list: [],
          claim_id_list: stateFromHistory?.claimIds,
          category: selectedFactor,
        },
      )
      .then((response) => {
        const formattedData = formatWasteCalculatorSummary(
          response?.data?.data,
        );
        setCohortCost(formattedData.costValues);
        setCohortMembers(formattedData.memberValues);
        setTotalClaims(formattedData.totalClaims);
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 8000);
      });
  };

  const getWastageCostTrendData = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.summaryBaseUrl +
          properties.costTrend,
        {
          ...payload,
          claim_id_list: stateFromHistory?.claimIds,
          member_unique_id_list: [],
          isWasteCategory: true,
          category: selectedFactor,
        },
      )
      .then((response) => {
        const costTrendData = response?.data?.data?.costTrend;
        for (let i = 0; i < costTrendData.length; i++) {
          const month = costTrendData[i]?.month - 1;
          if (
            costTrendTotalCostData?.length > month ||
            costTrendClaimsData?.length > month
          ) {
            costTrendTotalCostData[month].value += costTrendData[i]?.total_cost;
            costTrendClaimsData[month].value += costTrendData[i]?.total_claims;
          } else {
            costTrendTotalCostData?.push({
              value: costTrendData[i]?.total_cost,
            });
            costTrendClaimsData?.push({
              value: costTrendData[i]?.total_claims,
            });
          }
          if (costTrendChartXAxisValues?.length <= month) {
            costTrendChartXAxisValues?.push({
              label: getMonth(costTrendData[i]?.month, costTrendData[i]?.year),
            });
          }
        }
        setCostTrendTotalCostData([...costTrendTotalCostData]);
        setCostTrendClaimsData([...costTrendClaimsData]);
        setCostTrendChartXAxisValues([...costTrendChartXAxisValues]);
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 8000);
      });
  };

  const getClaimsData = async (ClaimIds: string[]) => {
    return await axios
      .post(
        properties.aiqBaseUrl +
          properties.membersBaseUrl +
          properties.memberDetails,
        {
          ...payload,
          member_unique_id: [],
          claim_id_list: ClaimIds,
        },
      )
      .then((response) => response.data);
  };

  const getSubCategoriesByWastageCategory = async () => {
    setSubCategoriesLoading(true);

    try {
      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.wasteCalculatorBaseUrl +
          properties.wastageSubCategories,
        {
          ...payload,
          member_unique_id_list: [],
          claim_id_list: [],
          category: selectedFactor,
          sortField: subCategoriesSortField,
          sortOrder: subCategoriesSortOrder,
          pageNumber: subCategoriesPageNumber - 1,
          pageSize: subCategoriesPageSize,
        },
      );

      if (response?.status === 200) {
        const updatedData = await Promise.all(
          response?.data?.data?.subCategories?.map(async (subCategory: any) => {
            const claimsData = await getClaimsData(subCategory?.claimIds);

            return [
              getTextWithToolTip(subCategory?.wastageSubCategory ?? '-', 40),
              numberToCurrencyFormatter(subCategory?.totalCost),
              numberToCurrencyFormatter(subCategory?.averageCost),
              subCategory?.totalMembers,
              subCategory?.totalClaims,
              <MedicalHistoryDetails
                riskPatientDetails={formatMemberClaim(claimsData?.data)}
              />,
            ];
          }),
        );

        setSubCategoriesTotalPages(
          Math.ceil(response?.data?.data?.totalCount / subCategoriesPageSize),
        );
        setSubCategoriesData(updatedData);
      }
    } catch (error: any) {
      handleOpenSnackBar(error.response?.data?.error, 'error', 8000);
    } finally {
      setSubCategoriesLoading(false);
    }
  };

  const getTopProvidersDataByWastageCategory = async () => {
    setTopProvidersLoading(true);

    try {
      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.wasteCalculatorBaseUrl +
          properties.wastageTopProviders,
        {
          ...payload,
          member_unique_id_list: [],
          claim_id_list: [],
          providerType:
            topProvidersToggle === 'left' ? 'Physician' : 'Facility',
          category: selectedFactor,
          sortField: topProvidersSortField,
          sortOrder: topProvidersSortOrder,
          pageNumber: topProvidersPageNumber - 1,
          pageSize: topProvidersPageSize,
        },
      );

      if (response?.status === 200) {
        const updatedData = await Promise.all(
          response?.data?.data?.topProviders?.map(async (topProvider: any) => {
            const claimsData = await getClaimsData(topProvider?.claimIds);

            return [
              getTextWithToolTip(topProvider?.providerName ?? '-', 40),
              numberToCurrencyFormatter(topProvider?.totalCost),
              numberToCurrencyFormatter(topProvider?.averageCost),
              topProvider?.totalMembers,
              topProvider?.totalClaims,
              <MedicalHistoryDetails
                riskPatientDetails={formatMemberClaim(claimsData?.data)}
              />,
            ];
          }),
        );

        setTopProvidersTotalPages(
          Math.ceil(response?.data?.data?.totalCount / topProvidersPageSize),
        );
        setTopProvidersData(updatedData);
      }
    } catch (error: any) {
      handleOpenSnackBar(error.response?.data?.error, 'error', 8000);
    } finally {
      setTopProvidersLoading(false);
    }
  };

  const membersListRequestBody = {
    ...payload,
    member_unique_id_list: [],
    pageNumber: membersPageNumber - 1,
    pageSize: membersPageSize,
    sortField: membersSortField,
    sortOrder: membersSortOrder,
    max_claim_date: employerGroupStore.employerGroupResponseData.max_claim_date,
    columnList: selectedColumns,
    category: selectedFactor,
  };

  const getMembersList = async () => {
    setMembersLoading(true);

    const response = await axios.post(
      properties.aiqBaseUrl +
        properties.wasteCalculatorBaseUrl +
        properties.wastageCategoryMembersList,
      membersListRequestBody,
    );

    if (response?.status === 200) {
      const updatedData = await Promise.all(
        response?.data?.data?.membersList?.map(async (item: any) => {
          const memberClaimsData = await getClaimsData(item?.claims);
          return {
            ...item,
            claimData: memberClaimsData?.data,
          };
        }),
      );

      setMembersTotalPages(
        Math.ceil(response?.data?.data?.totalMembers / membersPageSize),
      );
      setMemberListData(formatMembersListData(updatedData, selectedColumns));
      setMembersLoading(false);
    }
  };

  const getAllApis = async () => {
    setPageLoading(true);
    isPlanDatesFetched &&
      (await Promise.allSettled([
        getWasteCalculatorSummary(),
        getWastageCostTrendData(),
      ])
        .then(() => setPageLoading(false))
        .finally(() => {
          setPageLoading(false);
        }));
  };

  //useEffects
  useEffect(() => {
    getSubCategoriesByWastageCategory();
  }, [
    subCategoriesPageNumber,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    subCategoriesSortField,
    subCategoriesSortOrder,
    selectedFactor,
  ]);

  useEffect(() => {
    getTopProvidersDataByWastageCategory();
  }, [
    topProvidersPageNumber,
    topProvidersToggle,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    topProvidersSortOrder,
    topProvidersSortField,
    selectedFactor,
  ]);

  useEffect(() => {
    getMembersList();
  }, [
    membersPageNumber,
    membersSortField,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    membersSortOrder,
    selectedFactor,
  ]);

  useEffect(() => {
    getAllApis();
  }, [
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    selectedFactor,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  useEffect(() => {
    if (clickedMember) {
      memberSummaryStore.setPathDetails([
        [
          'text',
          selectedFactor,
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
        ],
      ]);
      navigate(PATIENT_DETAILS, { state: { memberId: clickedMember } });
    }
  }, [clickedMember]);

  //Components
  const WasteCalculatorCards = () => {
    const { totalCost, memberValues, costValues } = summaryStore;

    return (
      <Grid container className={classes.topCardsGrid}>
        <OverviewCardTooltipContent
          type={'member'}
          cohortMemberValues={cohortMembers}
          totalMemberValues={memberValues}
          overviewCard={
            <OverviewCard
              title={messages.COHORT_MEMBERS}
              value={getCohortValue(
                cohortMembers?.members,
                memberValues?.members,
              )}
              rootStyles={{
                width: '176px',
                fontWeight: 600,
                fontSize: ' 24px',
              }}
            />
          }
        />
        <OverviewCardTooltipContent
          type={'cost'}
          cohortCostValues={cohortCost}
          totalCostValues={costValues}
          overviewCard={
            <OverviewCard
              title={messages.COHORT_COST}
              value={getCohortValue(
                '$' +
                  numFormatterWithSuffix(
                    Number(cohortCost.total?.substring(1)?.replaceAll(',', '')),
                  ),
                totalCost?.totalCost,
              )}
              rootStyles={{
                width: '216px',
              }}
              labelsMinWidth="72px"
            />
          }
        />
        <OverviewCard
          title={messages.COHORT_CLAIMS}
          value={numberToCurrencyFormatter(totalClaims, false, 0)}
          rootStyles={{
            width: '176px',
            fontWeight: 600,
            fontSize: ' 24px',
          }}
        />
      </Grid>
    );
  };

  return (
    <>
      {pageLoading || isPlanDatesLoading ? (
        loader
      ) : (
        <Grid container className={classes.root}>
          <Grid className={classes.breadcrumbsGrid}>
            <Breadcrumbs itemList={breadcrumbs} />
          </Grid>
          <PageTitleAndSubTitle
            title={
              <div className={classes.flex}>
                <DashedStandardDropdown
                  height="24px"
                  value={selectedFactor}
                  options={listOfFactors}
                  displayValue={listOfFactors}
                  handleChange={(event: any) => {
                    const value: string = event.target.value as string;
                    wasteCalculatorStore.setCategory(value);
                    setSelectedFactor(value);
                    //set to defaults if category changes
                    setSubCategoriesPageNumber(1);
                    setSubCategoriesSortField('totalCost');
                    setSubCategoriesSortOrder(-1);

                    setTopProvidersPageNumber(1);
                    setTopProvidersSortField('totalCost');
                    setTopProvidersSortOrder(-1);
                  }}
                />
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="0px 8px"
                >
                  {messages.FOR}
                </Typography>
                <DateFilter />
              </div>
            }
            subTitle={messages.SUB_TITLE}
            showDownloadButton={true}
            downloadButtonAction={handleReportDownload}
          />
          <TabSelection
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={handleSelectedIndex}
            recommendationFetched={recommendationFetched}
          />
          <Grid className={classes.tabContent}>
            {selectedTabIndex === 0 && (
              <Grid className={classes.overviewVisualsGrid}>
                <WasteCalculatorCards />
                <CardComponent
                  title={messages.SUB_CATEGORIES_TABLE.TITLE}
                  subTitle={`${messages.SUB_CATEGORIES_TABLE.SUB_TITLE} ${selectedFactor}`}
                  body={
                    subCategoriesLoading ? (
                      <Grid className={classes.tableLoaderGrid}>
                        <CircularLoader />
                      </Grid>
                    ) : (
                      <Grid>
                        <BasicTable
                          displayType="row"
                          columns={subCatergoriesTableColumns}
                          rowsData={subCategoriesData}
                          isCollapsiblePatientTable={true}
                          isToolTipFirstColumn={true}
                          isFullTable
                          showOnHoverHeader={true}
                          columnId={columnIdForSubCategories}
                          handleHeaderMouseEnter={(column: any) =>
                            handleHeaderMouseEnter(
                              column,
                              setColumnIdForSubCategories,
                            )
                          }
                          handleHeaderMouseLeave={() =>
                            handleHeaderMouseLeave(setColumnIdForSubCategories)
                          }
                          handleMenuItem={handleMenuItemForSubCategories}
                          showPagination={true}
                          pageCount={subCategoriesTotalPages}
                          pageNumber={subCategoriesPageNumber}
                          handlePagination={handleTablePageChangeForSubCatories}
                        />
                      </Grid>
                    )
                  }
                  width="1175px"
                />
                <CardComponent
                  title={messages.TOP_PROVIDERS_TABLE.TITLE}
                  subTitle={messages.TOP_PROVIDERS_TABLE.SUB_TITLE}
                  body={
                    topProvidersLoading ? (
                      <Grid className={classes.tableLoaderGrid}>
                        <CircularLoader />
                      </Grid>
                    ) : (
                      <Grid>
                        <BasicTable
                          displayType="row"
                          columns={topProvidersTableColumns}
                          rowsData={topProvidersData}
                          isCollapsiblePatientTable={true}
                          isToolTipFirstColumn={true}
                          isFullTable
                          showOnHoverHeader={true}
                          columnId={columnIdForTopProviders}
                          handleHeaderMouseEnter={(column: any) =>
                            handleHeaderMouseEnter(
                              column,
                              setColumnIdForTopProviders,
                            )
                          }
                          handleHeaderMouseLeave={() =>
                            handleHeaderMouseLeave(setColumnIdForTopProviders)
                          }
                          handleMenuItem={handleMenuItemForTopProviders}
                          showPagination={true}
                          pageCount={topProvidersTotalPages}
                          pageNumber={topProvidersPageNumber}
                          handlePagination={
                            handleTablePageChangeForTopProviders
                          }
                        />
                      </Grid>
                    )
                  }
                  width="1175px"
                  topRightItem={
                    <ToggleGroup
                      leftValue={messages.TOGGLE_VALUES.leftValue}
                      rightValue={messages.TOGGLE_VALUES.rightValue}
                      leftIcon={<Layers className={classes.icon} />}
                      rightIcon={<SvgTable className={classes.icon} />}
                      setSelectedToggle={setTopProvidersToggle}
                    />
                  }
                />
                <CostTrend
                  {...wastageCostTrendProps(
                    costTrendTotalCostData,
                    costTrendClaimsData,
                    costTrendChartXAxisValues,
                  )}
                />
                <CustomColumnsTable
                  title={'Members Details'}
                  subTitle={`View the members under ${selectedFactor}`}
                  options={subCategoriesColumns}
                  mandateOptions={['Member ID']}
                  selectedItems={selectedColumns}
                  setSelectedItems={setSelectedColumns}
                  handleChangeColumns={handleChangeColumns}
                  handleExport={handleExportCSV}
                  columns={tableColumns}
                  rowsData={memberListData}
                  tableLoading={membersLoading}
                  handleMemberClick={handleMemberClick}
                  handleSort={handleMenuItemForMembers}
                  totalPages={membersTotalPages}
                  handlePageChange={handleTablePageChangeForMembers}
                  pageNumber={membersPageNumber}
                />
              </Grid>
            )}
            {selectedTabIndex === 1 && (
              <RecommendationsTab
                recommendationLoading={recommendationLoading}
                isInternalPage={true}
              />
            )}
          </Grid>
          <div id="scroll-top-element"></div>
          {pageScrollDown('scroll-top-element')}
        </Grid>
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
};
export default WasteCalculatorDetailsPage;
